import React from "react";

export default function Radio({
  checked,
  active,
  onChange,
  name,
  className = "",
  readOnly = false,
  disabled = false,
  variant = "default",
  onKeyDown,
}) {
  const isChecked = typeof checked === "boolean" ? checked : !!active;
  const interactive = typeof onChange === "function" && !readOnly && !disabled;
  const isAfrimed = variant === "afrimed";
  const baseClassName = isAfrimed
    ? [
        "grid h-6 w-6 place-items-center rounded-full transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[rgb(var(--afrimed-primary))]",
        interactive ? "cursor-pointer" : "cursor-default",
        disabled ? "opacity-50 cursor-not-allowed" : "",
        className,
      ].join(" ")
    : [
        "grid h-5 w-5 place-items-center rounded-full border border-border transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        isChecked ? "bg-primary" : "bg-white",
        interactive ? "cursor-pointer" : "cursor-default",
        disabled ? "opacity-50 cursor-not-allowed" : "",
        className,
      ].join(" ");

  const visual = isAfrimed ? (
    <span
      aria-hidden="true"
      className={`grid h-5 w-5 place-items-center rounded-full border transition ${
        isChecked
          ? "border-[rgb(var(--afrimed-primary))] bg-[rgba(29,78,216,0.06)]"
          : "border-[rgba(var(--clr-on-surface-variant),0.72)] bg-[rgba(var(--clr-on-surface-variant),0.08)]"
      }`}
    >
      <span className={`h-2.5 w-2.5 rounded-full ${isChecked ? "bg-[rgb(var(--afrimed-primary))]" : "bg-transparent"}`} />
    </span>
  ) : (
    <span
      aria-hidden="true"
      className={`h-2.5 w-2.5 rounded-full ${isChecked ? "bg-primary-foreground" : "bg-transparent"}`}
    />
  );

  const select = (event) => {
    if (!interactive) return;
    event?.stopPropagation?.();
    onChange?.(!isChecked);
  };

  const handleKeyDown = (event) => {
    event.stopPropagation();
    if (!interactive) return;
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      onChange?.(!isChecked);
      return;
    }
    onKeyDown?.(event);
  };

  return (
    <div
      role="radio"
      aria-checked={isChecked}
      aria-label={name || undefined}
      aria-readonly={readOnly || undefined}
      aria-disabled={disabled || undefined}
      tabIndex={interactive ? 0 : -1}
      onClick={select}
      onKeyDown={handleKeyDown}
      onMouseDown={(event) => event.stopPropagation()}
      onTouchStart={(event) => event.stopPropagation()}
      className={baseClassName}
    >
      {visual}
    </div>
  );
}
